import React from 'react';
import PropTypes from 'prop-types';
import * as moment from 'moment';
import SubHeaderItem from '../list/listItem/SubHeaderItem';
import CourseProp from '../../academy/propTypes/courseProp';

export default function CourseItem({ t, course, showCertificateInfo, showModules, onCourseSelected, isFromSession }) {
  const subHeaderItems = [];
  if (!isFromSession) {
    const duration = moment.duration(course.duration);
    if (duration > 0) {
      subHeaderItems.push({
        icon: 'la la-clock-o',
        title: t('academy_duration'),
        value: `${duration.hours()}h:${duration.minutes()}m`,
        valueClass: '',
      });
    }
  }

  if (showModules) {
    subHeaderItems.push({
      icon: 'la la-list',
      title: t('academy_modules'),
      value: course.modules,
      valueClass: '',
    });
  }

  if (showCertificateInfo) {
    subHeaderItems.push({
      icon: 'la la-certificate',
      title: t('academy_certificate'),
      value:
        course.certificate && course.certificate.isActive ? t('yes') : t('no'),
      valueClass:
        course.certificate && course.certificate.isActive
          ? 'm--font-success fix-weight'
          : 'm--font-danger fix-weight',
    });
  }

  const image = course.imageSquare || course.image;

  const imageURL = image ? image.thumb : '/images/no_image_upload.png';

  return (
    <div className="row">
      <button
        type="button"
        onClick={() => onCourseSelected(course._id)}
        className="course-container col-12"
      >
        <div className="row mobile-container">
          <div className="col-lg-5 col-md-3 col-12 image-container">
            <img
              src={imageURL}
              alt="course"
            />
          </div>
          <div className="col-lg-7 col-md-6 col-12 content-container">
            <div className="course-details">
              <div className="course-header">
            <span
              itemProp="name"
              content={course.name}
              className="course-header-name"
            >
              {course.name}
            </span>
              </div>
              <div className="course-subheader">
                {subHeaderItems.map(item => (
                  <div className="row">
                    <SubHeaderItem key={item.title} item={item} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </button>
    </div>
  );
}

CourseItem.propTypes = {
  t: PropTypes.func.isRequired,
  meta: PropTypes.shape({ url: PropTypes.string }),
  course: PropTypes.shape(CourseProp.propType).isRequired,
  showModules: PropTypes.bool,
  showCertificateInfo: PropTypes.bool,
  onCourseSelected: PropTypes.func.isRequired,
  /** Identify if course is inside the session, if so dont show duration */
  isFromSession: PropTypes.bool,
};

CourseItem.defaultProps = {
  showModules: true,
  showCertificateInfo: true,
  meta: null,
  isFromSession: false,
};
